import type { DpEvent } from '@/core/events/DpEvent';

export class PhoneWidgetEvent implements DpEvent {
  constructor(readonly name: string) {}
}
